import { Injectable } from '@angular/core';
import { FqsrCertificateUrlServices } from './fqsr-certificate-model';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { urlServices } from 'src/app/griviance/models/url.models';
import { encryptionService } from '../common-service/cedService';
import { ServerURLService } from '../common-service/serverURL.service';

@Injectable({
  providedIn: 'root'
})
export class  FqsrCertificateService {
  public dateValue = '';
  
  constructor(public http: HttpServiceService,private url: FqsrCertificateUrlServices,private urlGr:urlServices, 
    public ced: encryptionService, public serverURL: ServerURLService) { }

  getAllCourses() {
    return this.http.get(this.url.fqsrCourseList);
  }
 
  getEligibilityCertificateUserDetails(emailId){
    return this.http.get(this.url.fqsrUserInfo+'?emailId='+emailId);
  }

  getFqsrApplicationInfoDetails(requestId){
    const obj = {
      fqsrAppReqId: this.ced.encryptAesToString(requestId, this.serverURL.secretKey).toString(),
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.fqsrApplicationInfo, obj);
  }
  
  fqsrRegistration(data: any) {
    return this.http.post(this.url.fqsrRegistration, data);
  }
  additionalDocsDelete(id: any) {
    return this.http.post<any>(this.url.additionalDocsDelete + "?id=" + id,'');
  }
  fqsrImmiuploadFiles(formdata: any, Ids: any, tableNames: any, requestId: any) {
    return this.http.post<any>(this.url.fqsrImmiuploadFiles + "?Ids=" + Ids + "&tableNames=" + tableNames + "&fqsrReqId=" + requestId, formdata);
  }

  saveFQSRCertificatReApplied(requestId){
    const obj = {
      fqsrAppReqId: this.ced.encryptAesToString(requestId, this.serverURL.secretKey).toString(),
      roleName: this.ced.encryptAesToString(sessionStorage.getItem('selectedRole-usec'), this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.saveFQSRCertificatReApplied, obj);
  }

  getRegisteredUserinformation(emailId){
    return this.http.get(this.url.getRegisteredUserinformation+'?emailId='+emailId);
  }
  public loadEndate(date) {
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    return date.getFullYear()+'-'+month+'-'+day
  }
  public personalloadEndate(date) {
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    return date.getFullYear()-19+'-'+month+'-'+day
  }
  
  getSectionDashboardInformation(currentOwner){
    return this.http.get(this.url.getSectionDashboardInformation+'?currentOwner='+currentOwner);
  }

  submitSectionExecutiveForm(data: any) {
    return this.http.post(this.url.submitSectionExecutiveForm, data);
  }

  submitSectionExecutiveHeadForm(data: any) {
    return this.http.post(this.url.submitSectionExecutiveHeadForm, data);
  }
  submitSubCmtForm(data: any) {
    return this.http.post(this.url.submitSubCmtForm, data);
  }
  submitExeCmtForm(data: any) {
    return this.http.post(this.url.submitExeCmtForm, data);
  }
  submitSecretaryForm(data: any) {
    return this.http.post(this.url.submitSecretaryForm, data);
  }
 
  
  stateList(){
    return this.http.get(this.url.stateList);
  }
  cityList(){
    return this.http.get(this.url.cityList);
  }
  countryList(){
    return this.http.get(this.url.countryList);
  }
  
  getAgendaItemNumber() {
    return this.http.get(this.urlGr.getAgendaItemNumberFqsr);
  }

  createAgenda(data: any) {
    return this.http.post(this.urlGr.createAgendaForFqsr, data);
  }
  getExistsAgendaDetails(applicationId:any) {
    return this.http.get(this.urlGr.getExistsAgendaDetailsFqsr+ '?applicationId=' + applicationId);
  }

  getExistsAgenda(applicationId:any) {
    return this.http.get(this.urlGr.getExistsAgendaFqsr+ '?applicationId=' + applicationId);
  }

  fwdToSubCommittee(data: any) {
    return this.http.post(this.url.fwdToSubCommittee, data);
  }
  subComFqsrDecision(data: any) {
    return this.http.post(this.urlGr.subComFqsrDecision, data);
  }

  uploadFile(files:any, regId) {
     var formdata: FormData = new FormData();
     for (let i = 0; i < files.length; i++) {
      formdata.append('files', files[i]);
    }
      
      return this.http.post<any>(this.url.applicantFileUpload+"?regId="+regId, formdata);
    }
  searchDashboard(dataa: any, pageId: number, rowId: number) {
    return this.http.get(this.url.seacrhDashboardBySearchInput + '?searchInput=' + dataa + '&page=' + pageId + '&rows=' + rowId)
  }
  getAllFqsrDashboardByUser(userId, pageId, rows) {
    return this.http.get(this.url.getAllFqsrDashboardByUser + '?userId=' + userId + '&page=' + pageId + '&rows=' + rows)
  }
  dashBoardSearch(page, rowNumber, input) {
    var formdata: FormData = new FormData();
    formdata.append('fqsrJson', JSON.stringify(input));
    return this.http.post(this.url.dashBoardSearch + '?page=' + page + '&rows=' + rowNumber, input)
  }

  getSectionRemarks(applicationId){
    return this.http.get(this.url.getSectionRemarks+'?applicationId='+applicationId);
  }

  secHeadFinalDecision(data: any) {
    return this.http.post(this.url.secHeadFinalDecision, data);
  }

  getProfilePicUrl(fileName: any){
    const obj = {
      fileByteName : fileName,
    }
    return this.http.post(this.url.applicantProfileUrl, obj);
  }

  getProfileSignUrl(fileName: any){
    const obj = {
      fileByteName : fileName,
    }
    return this.http.post(this.url.applicantSignUrl, obj);
  }

  findFQSRDashboardList(fqsrDashboardSearchCriteria: any){
    return this.http.post(this.url.getFQSRDashboardList, fqsrDashboardSearchCriteria);
  }

  findFQSRTrackDashboardList(fqsrDashboardSearchCriteria: any){
    return this.http.post(this.url.getFQSRTrackDashboardList, fqsrDashboardSearchCriteria);
  }

  getFQSRListExportPdf(fqsrDashboardSearchCriteria: any) {
    return this.http.post(this.url.getFQSRListExportPdf, fqsrDashboardSearchCriteria);
  }

  getFQSRListExportExcel(fqsrDashboardSearchCriteria: any) {
    return this.http.post(this.url.getFQSRListExportExcel, fqsrDashboardSearchCriteria);
  }

  getAllFQSRStatus() {
    return this.http.get(this.url.findAllFQSRStatus);
  }

  assignFQSRRequest(data: any) {
    return this.http.post(this.url.assignFQSRRequest, data);
  }

  getFQSRProcessHistory(fqsrAppReqId: any, sort: any) {
    const obj = {
      fqsrAppReqId : this.ced.encryptAesToString(fqsrAppReqId, this.serverURL.secretKey).toString(),
      sort: sort
    }
    return this.http.post(this.url.getFQSRProcessHistory, obj);
  }

    // FQSR Workfloq Document  
  fqsrWorkflowWithDocument(obj: any, filearray: any) {
  const formdata = new FormData();
  formdata.append('fqsrEncryptDTOStr', JSON.stringify(obj));
  for (let i = 0; i < filearray.length; i++) {
    formdata.append('file', filearray[i]);
  }
    return this.http.post(this.url.fqsrWorkflowWithDocument, formdata);
  }

  getFQSRNoteSheetPurpose() {
    return this.http.get(this.url.getFQSRNoteSheetPurpose);
  }

  getActiveFqsrApplicationCount() {
    return this.http.get(this.url.getActiveFqsrApplicationCount);
  }

  updateFQSRPaymentDetails(obj){
    return this.http.post(this.url.updateFQSRPaymentDetails,obj);
  }

}
